/**
 * Author-facing labels for AnswerType kinds. The internal kind strings
 * ('integer', 'string', 'free_text', …) stay the discriminator the shared
 * zod schema validates against — only the UI label changes. Keep this map
 * in one place so the dropdown and any chips agree.
 *
 * The two text kinds are named for what the agent does with the reply, not
 * its length: `string` listens for a specific answer and can ask again,
 * `free_text` keeps whatever the caller says.
 */
export const ANSWER_TYPE_LABELS = {
    yes_no: 'Yes / No',
    options: 'Options',
    integer: 'Number',
    string: 'Specific answer',
    zip: 'Zip code',
    email: 'Email',
    date: 'Date',
    free_text: 'Any answer',
};
/**
 * One line shown under the dropdown for the two text kinds, whose names
 * alone don't say when the agent asks again. Mirrors the runtime in
 * apps/livekit/node-agent/node_agent/graph/form_executor.py.
 */
export const ANSWER_TYPE_HINTS = {
    string: 'Pulls the answer out of the reply. Asks again once only if the caller didn’t try to answer.',
    free_text: 'Keeps exactly what the caller says. Never asks again.',
};
/**
 * Display order for the dropdown. Grouped by familiarity: binary, choice,
 * number, text (specific → any), formats (zip/email/date).
 */
export const ANSWER_TYPE_ORDER = [
    'yes_no',
    'options',
    'integer',
    'string',
    'free_text',
    'zip',
    'email',
    'date',
];
export function answerTypeLabel(answerType) {
    if (!answerType)
        return ANSWER_TYPE_LABELS.string;
    return ANSWER_TYPE_LABELS[answerType.kind] ?? ANSWER_TYPE_LABELS.string;
}
//# sourceMappingURL=answer-type-labels.js.map